import Text from "@/components/common/Text"
import React from "react"

export default function DefaultHeader({ color, header }) {
	return (
		<Text color={color} tag="h2" className="typo-borna typo-borna-10 header">
			{header}
		</Text>
	)
}
